export default {
  api: [
    { rule: "lcagent.*", allow: true },
    { rule: "lcgroup.*", allow: true },
  ],
};
